const adminApps = {
  actions: {
    channels: 'Usage channels',
    add: 'Add app',
    delete: 'Delete app',
    edit: 'Edit app',
    im: 'IM integration',
    members: 'Members',
    open: 'Open actions for {{name}}',
  },
  channels: {
    title: 'Usage channels',
    description:
      'Choose where users who already have app permission can see and use this app. Channel settings do not grant app permission.',
    loading: 'Loading channel settings…',
    loadFailed: 'Could not load channel settings. Try again.',
    saved: 'Usage channels updated',
    saveFailed: 'Could not save. Check your app edit permission and try again.',
    allClosed:
      'All channels are closed. Users cannot see or use this app. Existing installations, favorites, and conversations are retained.',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving…',
    options: {
      web_standard: {
        label: 'Standard Web',
        description: 'Web access through password or general SSO sign-in.',
      },
      web_wecom: { label: 'WeCom', description: 'Web access through WeCom passwordless sign-in.' },
      im: { label: 'IM', description: 'App access through connected messaging bots.' },
    },
  },
  columnSelector: {
    label: 'Choose app list columns',
    trigger: 'Columns',
  },
  description:
    'View enterprise app assets, lifecycle, publishing status, visibility, and ownership.',
  empty: 'No apps yet',
  emptyDescription: 'No description',
  deleteDialog: {
    cancel: 'Cancel',
    close: 'Close delete confirmation',
    confirm: 'Delete',
    failed: 'Failed to delete app. Try again later.',
    message:
      'Deleting "{{name}}" removes its app config, visibility scope, integrations, and platform-managed usage and conversation records.',
    subtitle: 'Deleted apps cannot be restored!',
    success: 'App deleted',
    title: 'Delete app?',
  },
  drawer: {
    avatarFallback: 'New',
    cancel: 'Cancel',
    confirm: 'Confirm',
    configFields: {
      api_host: 'API Host',
      api_key: 'API Key',
      app_key: 'ADP App Key',
      chat_base_url: 'ADP chat base URL',
      credential_id: 'Tencent ADP credential',
      custom_params: 'Custom parameters',
      openapi_endpoint: 'ADP OpenAPI Endpoint',
      registered_model_id: 'Agent model',
      show_tool_invocation_details: 'Show Tool details',
      show_process_details: 'Show ADP process details',
      show_workflow_details: 'Show workflow details',
      system_prompt: 'System prompt',
      tencent_region: 'Tencent Cloud Region',
      tencent_secret_id: 'Tencent Cloud SecretId',
      tencent_secret_key: 'Tencent Cloud SecretKey',
      url_template: 'App URL template',
      websocket_endpoint: 'ADP WebSocket Endpoint',
    },
    configFieldHints: {
      show_tool_invocation_details:
        'When off, chat still shows whether each Tool completed or failed, without exposing its input and output.',
    },
    createTitle: 'New app',
    detailLoadFailed: 'Try again later, or check whether this admin still has app access.',
    detailLoadFailedTitle: 'Failed to load app detail',
    editTabs: {
      basic: 'Basic info',
      config: 'App config',
      configEmpty: 'This app type has no extra configuration.',
      createdAt: 'Created at',
      label: 'Edit app tabs',
      lifecycle: 'Lifecycle',
      updatedAt: 'Updated at',
    },
    editTitle: 'Edit / {{name}}',
    fields: {
      avatar: 'App icon',
      appConfig: 'App config',
      appType: 'App type',
      description: 'Description',
      name: 'App name',
      tags: 'Business tags',
      version: 'Version',
    },
    feedback: {
      adpValidationFailed: 'ADP app test failed',
      adpValidationPassed: 'ADP app test passed',
      configValidationFailed: 'Config validation failed',
      createSuccess: 'App created',
      submitFailed: 'Save failed',
      updateSuccess: 'App saved',
      validationFailed: 'Fix the form first',
    },
    nameAvailability: {
      available: 'Name is available',
      checking: 'Checking name availability…',
      failed: 'Name availability could not be checked. Try again later.',
    },
    hideSecret: 'Hide secret',
    iconPicker: {
      cancel: 'Cancel',
      change: 'Change',
      chooseAnother: 'Choose another image',
      chooseFile: 'Choose image',
      confirm: 'Use this icon',
      cropFailed: 'The image could not be cropped. Choose another image and try again.',
      cropPreview: 'App icon crop preview',
      horizontal: 'Horizontal position',
      open: 'Choose app icon',
      presetDescription: 'Choose a preset icon. You can replace it at any time.',
      presetLoadFailed: 'The preset icon could not be loaded. Try again or upload an image.',
      presets: {
        career: 'Career',
        coding: 'Coding',
        grading: 'Grading',
        illustration: 'Illustration',
        language: 'Language',
        learning: 'Learning',
        meeting: 'Meeting notes',
        presentation: 'Presentation',
        promotion: 'Promotion',
        prompt: 'Prompting',
        questions: 'Question design',
        writing: 'Writing',
      },
      tabs: {
        presets: 'Preset icons',
        upload: 'Upload and crop',
      },
      tabsLabel: 'App icon source',
      title: 'Choose app icon',
      uploadDescription:
        'Upload your own image, then adjust its zoom and position for a square crop.',
      uploadReadFailed: 'This image could not be read. Choose another image and try again.',
      vertical: 'Vertical position',
      zoom: 'Zoom',
    },
    oidc: {
      bindingDescription:
        'Select an existing client from IdP Clients. Callback URLs, credentials, and scopes are not duplicated in the app form.',
      client: 'OIDC client',
      clientActive: 'Enabled',
      clientInactive: 'Disabled',
      clientSelectionHint: 'Leave unselected when this app should not use OIDC passwordless login.',
      clientsLoadFailed: 'Failed to load OIDC clients.',
      noClient: 'No client',
      selectedClientScopes: 'Scopes: {{scopes}}',
      title: 'OIDC passwordless login',
    },
    save: 'Save',
    placeholders: {
      replaceSecret: 'Enter a new secret to replace it',
      appType: 'Select app type',
      description:
        'For example: helps sales teams answer customer questions, search materials, and suggest follow-ups.',
      name: 'Enter app name',
      secret: 'Enter secret',
      tags: 'Search or create business tags',
      tagsEmpty: 'No tags available',
      version: 'Enter, for example: 1.0.0',
    },
    registeredModels: {
      empty: 'No registered models available',
      loadFailed: 'Failed to load registered models. Try again later.',
      loading: 'Loading registered models...',
      placeholder: 'Select a registered model',
      unavailable: 'Saved model is unavailable',
    },
    adpCredentials: {
      empty: 'No Tencent ADP credentials available. Create one in credential management first.',
      loadFailed: 'Failed to load Tencent ADP credentials. Try again later.',
      loading: 'Loading Tencent ADP credentials...',
      manageLink: 'Manage credentials',
      placeholder: 'Select a Tencent ADP credential',
      unavailable: 'Saved credential is unavailable',
    },
    adpValidation: {
      successDetail: 'App ID: {{appId}}\nApp name: {{name}}',
      successDetailWithoutAppId: 'Connected to the ADP app.',
      successDetailWithoutName: 'App ID: {{appId}}',
      testApp: 'Test connection',
    },
    secretConfigured: 'A secret is configured. Leave this blank to keep it.',
    showSecret: 'Show entered secret',
    submitFailed: 'Failed to save. Try again later.',
    tags: {
      createOption: 'Create tag "{{name}}"',
      noMatches: 'No matching tags',
      remove: 'Remove tag {{name}}',
    },
    uploadAvatar: 'Upload app avatar',
    validation: {
      configInvalid: '{{label}} format is invalid',
      configRequired: '{{label}} is required',
      difyApiHost: 'API Host must start with http:// or https:// and end with /v1',
      chatBaseUrl: 'ADP chat base URL should stop at /adp/v2 and not include /chat/conn',
      nameRequired: 'Enter an app name',
      nameCheckFailed: 'The app name could not be verified. Try again later.',
      nameConflict: 'This app name is already in use. Choose another name.',
      typeRequired: 'Select an app type',
      urlProtocol: '{{label}} must start with http:// or https://',
      websocketUrl: '{{label}} must start with ws:// or wss://',
      versionInvalid: 'Version must look like 1.0.0',
    },
    wizard: {
      appTypeDescriptions: {
        default: 'The selected type determines the next configuration fields.',
        adp: 'Connect Tencent ADP via WebSocket mode.',
        dify: 'Connect a Dify app with API host and API key.',
        embed_url: 'Mount an external page through a URL template for existing systems.',
        self_agent: 'Use the AI Hub native agent runtime with model and prompt settings.',
      },
      basic: {
        versionHint: 'Leave blank when no version should be saved.',
      },
      config: {
        descriptionWithType: 'Fill in the connection details required by {{type}}.',
        empty: 'This app type has no extra configuration. You can continue.',
      },
      create: 'Create app',
      distribution: {
        assignmentFailed: 'Some member assignments failed. The app was rolled back. Try again.',
        effectiveCount: 'Estimated reach: {{count}} people',
        modeDescription: 'Choose how to distribute this app to authorized members.',
        modeTitle: 'App distribution',
        modes: {
          automatic: {
            description:
              'After publishing, the app appears in assigned users’ My Apps. Users can still remove it.',
            title: 'Add for all members',
          },
          manual: {
            description: 'The app is visible in the marketplace and users add it when needed.',
            title: 'Members add as needed',
          },
        },
        scopeDescription:
          'Assign whole departments, then add or exclude individual members as needed.',
        scopeTitle: 'Visibility and assignment scope',
      },
      headerDescription: 'Step {{current}} / {{total}}',
      lifecycle: {
        options: {
          active: 'After saving, automatically move through testing, publish request, and publish.',
          draft: 'Only save app configuration. Admins can advance publishing later.',
          pending_publish: 'After saving, automatically submit the app for publishing review.',
          testing: 'After saving, move the app into testing for quick validation.',
        },
        partialSubmitFailed:
          'The app was created, but it could not be moved to {{status}} automatically. Continue in publishing review.',
        targetDescription: 'Choose the lifecycle status immediately after the app is created.',
        targetLabel: 'Post-create status',
        transitionComment: 'Automatically advanced during app creation',
      },
      next: 'Next',
      previous: 'Previous',
      progress: 'Step {{current}} of {{total}}',
      progressLabel: 'Create app progress: step {{current}} of {{total}}, {{step}}',
      steps: {
        basic: {
          description: 'Start with the information users use to recognize the app.',
          title: 'Basic info',
        },
        config: {
          description: 'Fill in connection and runtime settings for the selected type.',
          title: 'App config',
        },
        distribution: {
          description: 'Choose the departments and members who can access the app.',
          title: 'Member assignment',
        },
        lifecycle: {
          description: 'Set how the app enters My Apps and its post-create status.',
          title: 'Publishing',
        },
        type: {
          description: 'The type controls which configuration fields come next.',
          title: 'App type',
        },
      },
    },
  },
  errorDescription: 'Try again later, or check whether this admin still has access.',
  errorDescriptionWithDetail: 'Backend response: {{detail}}',
  errorTitle: 'Failed to load apps',
  filters: {
    allStatuses: 'All statuses',
    allTypes: 'All app types',
    searchLabel: 'Search app name',
    searchPlaceholder: 'Search app name',
    statusLabel: 'Filter app status',
    typeLabel: 'Filter app type',
  },
  imDrawer: {
    appStatus: {
      description:
        'The platform callback is verified. This integration can now be enabled or disabled.',
      identityBlocked:
        'The callback is verified, but automatic binding for new users is not ready. Existing bindings still go through Portal authorization checks.',
      identityUnknown:
        'The callback is verified, but identity resolution permissions still require platform verification.',
      title: 'Integration status',
      verificationRequired: 'Save the config and verify the platform callback before enabling it.',
      wecom: {
        blocked:
          'The selected identity source or binding entry is unavailable. Resolve the configuration issue before enabling.',
        callbackBlocked:
          'Check the Token, EncodingAESKey, and WeCom callback configuration, then verify it again.',
        identity: {
          identity_profile_selected: 'Select an enabled WeCom identity source.',
          profile_agent_accessible:
            'The WeCom application is inaccessible. Ask a system administrator to check its Agent ID and permissions.',
          profile_agent_active:
            'The WeCom application is disabled. Ask a system administrator to enable it in WeCom.',
          profile_credential_valid:
            'The identity source credentials are unavailable. Ask a system administrator to test the connection again.',
        },
        unknown: 'Test the selected identity source connection before enabling this integration.',
      },
    },
    behavior: {
      feishu: {
        description: 'Portal enforces this policy. No duplicate setup is required in Feishu.',
        groupWhitelistPlaceholder:
          'Enter Feishu conversation IDs, separated by commas or new lines.',
        p2pWhitelistPlaceholder:
          'Enter Feishu user open_id values, separated by commas or new lines.',
      },
      group: 'Group chat policy',
      groupWhitelist: 'Group chat whitelist',
      p2p: 'Direct message policy',
      p2pWhitelist: 'Direct message whitelist',
      wecom: {
        description: 'Portal enforces this policy. No duplicate setup is required in WeCom.',
        groupWhitelistPlaceholder: 'Enter WeCom group chat IDs, separated by commas or new lines.',
        p2pWhitelistPlaceholder:
          'Enter WeCom userid or open_userid values, separated by commas or new lines.',
      },
    },
    cancel: 'Cancel',
    clear: 'Clear data',
    credentials: {
      feishu: {
        appId: 'App ID',
        appIdPlaceholder: 'Enter an App ID starting with cli_',
        appSecret: 'App Secret',
        appSecretPlaceholder: 'Enter App Secret',
        encryptKey: 'Encrypt Key',
        generatedDescription:
          'These values are shown once after creation. Save them now and configure them in Feishu.',
        generatedTitle: 'Save one-time callback security settings',
        secretHint: 'Leave App Secret blank to keep the saved value.',
        verificationToken: 'Verification Token',
      },
      copyEncryptKey: 'Copy Encrypt Key',
      copyVerificationToken: 'Copy Verification Token',
      preservePlaceholder: 'Saved. Leave blank to keep it',
      savedSecret: 'Sensitive settings are encrypted. Leave fields blank to keep them.',
      title: '{{platform}} credentials',
      wecom: {
        agentId: 'Agent ID',
        agentIdPlaceholder: 'Enter the WeCom custom app Agent ID',
        appSecret: 'App Secret',
        appSecretPlaceholder: 'Enter the WeCom custom app Secret',
        corpId: 'Corp ID',
        corpIdPlaceholder: 'Enter the enterprise ID starting with ww',
        encodingAesKey: 'EncodingAESKey',
        encodingAesKeyPlaceholder: 'Enter the WeCom EncodingAESKey',
        secretHint:
          'Token and EncodingAESKey secure callbacks for this Bot only. Leave saved fields blank to keep them.',
        token: 'Token',
        tokenPlaceholder: 'Enter the API mode WeCom bot Token',
      },
    },
    deleteDialog: {
      cancel: 'Cancel',
      close: 'Close confirmation',
      confirm: 'Clear',
      message: 'This will delete the current platform IM config, status, and policies.',
      subtitle: 'This calls the backend delete endpoint. Saved credentials cannot be restored.',
      title: 'Clear IM config?',
    },
    unsavedDialog: {
      continueEditing: 'Continue editing',
      discard: 'Discard changes',
      message:
        'The current platform config has unsaved changes. Save it before switching or closing.',
      save: 'Save and continue',
      subtitle: 'Discarding removes this draft without changing the last saved config.',
      title: 'Handle unsaved IM config',
    },
    errors: {
      deleteFailed: 'Failed to clear IM config. Try again later.',
      detailFailed: 'Try again later, or check whether this admin still has app access.',
      detailFailedTitle: 'Failed to load IM config',
      loadFailed: 'Try again later, or check whether this admin still has app access.',
      loadFailedTitle: 'Failed to load IM platforms',
      saveFailed: 'Failed to save IM config. Try again later.',
      copyFailed: 'Failed to copy the Callback URL. Copy it manually.',
      manifestFailed: 'Failed to load setup information. Try again later.',
      statusFailed: 'Failed to update IM status. Try again later.',
      validateFailed: 'Failed to validate IM config. Try again later.',
      verificationFailed: 'Failed to refresh callback verification. Try again later.',
    },
    feedback: {
      clearSuccess: 'IM config cleared',
      copySuccess: 'Callback URL copied',
      disableSuccess: 'IM disabled',
      enableSuccess: 'IM enabled',
      saveSuccess: 'IM config saved',
    },
    modes: {
      disabled: 'Disabled',
      open: 'Open',
      whitelist: 'Whitelist',
    },
    platformConfiguredDescription: 'Configuration exists. You can keep editing.',
    platformUnavailableDescription: 'This platform is not supported in the current version.',
    platformUnconfiguredDescription: 'Not configured. Ready to connect.',
    platforms: {
      dingtalk: {
        name: 'DingTalk',
      },
      feishu: {
        name: 'Feishu',
      },
      wecom: {
        name: 'WeCom',
      },
    },
    save: 'Save',
    sections: {
      behavior: 'Message access policy (Portal)',
      dataConfig: 'App data config',
      statusAndGuide: 'App status and setup guide',
      wecomSecurity: 'Callback security config',
      wecomIdentityProfile: 'WeCom identity source',
    },
    setupGuide: {
      callbackUrl: 'Callback URL',
      copyCallback: 'Copy Callback URL',
      feishu: {
        description:
          'Configure this Callback URL for Feishu event subscription and verify it with this integration.',
      },
      loading: 'Loading Callback URL…',
      saveFirst: 'Save this platform config to generate its Callback URL.',
      wecom: {
        botId: 'Bot ID',
        botIdUnknown: 'Not detected yet',
        description:
          'Configure the Callback URL, Token, and EncodingAESKey on the API mode WeCom bot.',
      },
    },
    status: {
      active: 'Enabled',
      comingSoon: 'Coming soon',
      disabled: 'Disabled',
      draft: 'Not enabled',
      unconfigured: 'Not configured',
    },
    title: 'IM integration',
    titleWithName: 'IM integration / {{name}}',
    unsupportedAppType: 'Only Dify and Tencent ADP apps can connect to IM in this release.',
    validate: 'Validate',
    validation: {
      failed: 'Validation found issues. Fix them before continuing.',
      passed: 'Validation passed.',
    },
    readiness: {
      actions: {
        aggregate: {
          blocked:
            'Resolve the identity source or callback blockers above before enabling this integration.',
          unknown:
            'You can enable the Bot to complete the first real user authorization. It is not fully ready until authorization succeeds and readiness is refreshed.',
        },
        callback: {
          blocked:
            'Check the Token, EncodingAESKey, and WeCom callback configuration, then verify again.',
          unknown:
            'Save the callback configuration, complete callback verification in WeCom, and refresh the status.',
        },
        profile: {
          blocked:
            'Ask a system administrator to check the identity source credentials, directory permissions, and data visibility scope.',
          unknown:
            'One real user QR-code authorization is required to verify enterprise email permission and data scope. This is not fully ready yet.',
        },
      },
      aggregate: 'Aggregate readiness',
      callback: 'Callback readiness',
      loading: 'Checking',
      profile: 'Identity source readiness',
      status: {
        blocked: 'Blocked',
        ready: 'Ready',
        unknown: 'Unknown',
      },
    },
    wecomProfile: {
      activeReadonly:
        'This integration is enabled. Disable it before changing the identity source.',
      available: 'Connection available',
      description:
        'Select the WeCom identity source used by this Bot. Portal checks application access separately.',
      emptyAppAdmin:
        'No identity source is available. Contact a system administrator to configure one.',
      emptySystemAdmin: 'No identity source is available. Create and enable one first.',
      field: 'WeCom identity source',
      loadFailed: 'Failed to load WeCom identity sources. Try again later.',
      manage: 'Manage identity sources',
      placeholder: 'Select an identity source',
      title: 'Identity source selection',
      unavailable: 'This identity source is unavailable. Ask a system administrator to check it.',
    },
    identityReadiness: {
      actions: {
        directory_scope_configured:
          'Include Bot users in the application directory visibility scope.',
        email_field_permitted: 'Grant the Bot application permission to read enterprise email.',
        identity_connector_supported:
          'This connector does not yet support trusted email resolution.',
        profile_api_accessible: 'Allow the Bot application to call the platform user profile API.',
        profile_credential_valid: 'Configure valid Bot credentials for user profile lookup.',
      },
      checks: {
        directory_scope_configured: 'Directory visibility scope',
        email_field_permitted: 'Enterprise email permission',
        identity_connector_supported: 'Identity connector',
        profile_api_accessible: 'User profile API',
        profile_credential_valid: 'Bot credentials',
      },
      description: {
        blocked:
          'Automatic binding is incomplete. First-time unbound users will not enter Runtime.',
        ready: 'First-time users can match their Portal account through trusted enterprise email.',
        unknown:
          'Permissions and directory scope have not yet been verified with a real platform profile lookup.',
      },
      loading: 'Checking',
      status: {
        blocked: 'Not ready',
        ready: 'Ready',
        unknown: 'Needs verification',
      },
      title: 'Identity resolution readiness',
      unknown: {
        directory_scope_configured: 'Requires a real user profile lookup.',
        email_field_permitted: 'Requires a real user profile lookup.',
        identity_connector_supported: 'Requires connector capability verification.',
        profile_api_accessible: 'Requires a real platform request.',
        profile_credential_valid: 'Requires a platform credential request.',
      },
    },
    verification: {
      lastVerified: 'Last verified: {{time}}',
      neverVerified: 'Not verified yet',
      refresh: 'Refresh verification',
      status: {
        failed: 'Verification failed',
        stale: 'Credentials changed; verify again',
        unverified: 'Unverified',
        verified: 'Verified',
        verifying: 'Verifying',
      },
      title: 'Callback verification',
    },
  },
  membersDrawer: {
    badges: {
      direct: 'Direct',
      excluded: 'Excluded',
      inherited: 'Inherited',
    },
    cancel: 'Cancel',
    companyLabel: 'Select company',
    companyLoading: 'Loading company',
    discardDialog: {
      cancel: 'Keep editing',
      close: 'Close warning',
      confirm: 'Discard and close',
      message: 'Closing the drawer will discard the current member and department changes.',
      subtitle: 'Member permission changes have not been saved. Save first, or discard them.',
      title: 'Discard unsaved changes?',
    },
    loadFailedDescription:
      'Try again later, or check whether this admin still has app member management access.',
    loadFailedTitle: 'Failed to load member permissions',
    members: {
      deselectPage: 'Clear page',
      emptyScope: 'No members in this scope',
      loadFailedDescription:
        'Try again later, or check whether this admin still has organization member access.',
      loadFailedTitle: 'Failed to load members',
      noEmail: 'No email',
      noSearchResults: 'No matching members',
      pageStatus: 'Page {{page}} / {{total}}',
      searchLabel: 'Search members',
      searchPlaceholder: 'Search member name or email',
      selectPage: 'Select page',
      selectDepartment: 'Select a department',
      scopeCount: '{{count}} members',
      selectMember: 'Grant access to {{name}}',
      unselectMember: 'Remove access from {{name}}',
    },
    save: 'Save',
    saveFailed: 'Failed to save member permissions. Try again later.',
    partialSaveFailed: '{{count}} account(s) were not saved. Try again later.',
    partialSaveFailedTitle: 'Member permissions partially saved',
    saveSuccess: 'Member permissions saved',
    saving: 'Saving',
    scopeTitle: 'App visibility scope',
    selected: {
      departmentsTab: 'Departments {{count}}',
      membersTab: 'Members {{count}}',
      noDepartments: 'No authorized departments',
      noMembers: 'No direct members',
      tabsLabel: 'Switch selected permission type',
      title: 'Permission config',
    },
    summary: {
      departments: 'Authorized departments {{count}}',
      directMembers: 'Direct members {{count}}',
      effectiveMembers: 'Effective members {{count}}',
    },
    title: 'Members',
    titleWithName: 'Members / {{name}}',
    tree: {
      bindDepartment: 'Grant access to department {{name}}',
      collapse: 'Collapse {{name}}',
      expand: 'Expand {{name}}',
      noResults: 'No matching departments',
      searchLabel: 'Search departments',
      searchPlaceholder: 'Search departments',
      sortAsc: 'Asc',
      sortDesc: 'Desc',
      title: 'Departments',
      unbindDepartment: 'Remove access from department {{name}}',
    },
  },
  review: {
    actions: {
      approve_for_testing: 'Move to testing',
      ban: 'Unpublish',
      open: 'Open publishing actions for {{name}}',
      process: 'Process',
      publish: 'Publish',
      republish: 'Republish',
      request_publish: 'Request publish',
      return_to_draft: 'Return to draft',
      return_to_testing: 'Return to testing',
      unpublish: 'Unpublish now',
      viewHistory: 'View history',
    },
    changeTypes: {
      active: 'Unpublish management',
      banned: 'Republish',
      draft: 'Testing submission',
      pending_publish: 'Publishing review',
      testing: 'Publish request',
    },
    columnSelector: {
      label: 'Choose publishing review list columns',
      trigger: 'Columns',
    },
    description: 'Handle app publishing, unpublishing, and lifecycle review.',
    directUnpublish: {
      cancel: 'Cancel',
      close: 'Close unpublish confirmation',
      commentHint: 'Optional. Record the reason for later traceability.',
      commentLabel: 'Unpublish reason',
      commentPlaceholder: 'Enter unpublish reason',
      confirm: 'Unpublish',
      description:
        'The app will be removed from the available market. Config and history stay intact.',
      success: 'App unpublished',
      submitFailed: 'Failed to unpublish. Try again later.',
      submitFailedWithDetail: 'Failed to unpublish: {{detail}}',
      subtitle: '{{name}} will move directly to banned status.',
      title: 'Unpublish app?',
    },
    drawer: {
      actionsLoadFailed: 'Failed to load available actions. Try again later.',
      activeDirectTip:
        'Published apps are unpublished directly from the row menu. History remains here.',
      availableActions: 'Available actions',
      availableActionsDescription:
        'Actions come from the backend lifecycle contract. The frontend only displays and submits them.',
      bannedOutsideFlow:
        'Banned is outside the normal publishing chain. You can republish or return to draft.',
      close: 'Close',
      commentHint: 'Optional. It will be saved to the transition record.',
      commentLabel: 'Review note',
      commentPlaceholder: 'Enter review note',
      history: 'Transition history',
      historyEmpty: 'No transition history yet',
      historyLoadFailed: 'Failed to load transition history. Try again later.',
      noActions: 'No available action for the current status.',
      noDescription: 'No description',
      progressLabel: 'App publishing lifecycle',
      submit: 'Select action',
      submitFailed: 'Failed to update status. Try again later.',
      submitFailedWithDetail: 'Failed to update status: {{detail}}',
      title: 'Publishing review',
      titleWithName: 'Publishing review / {{name}}',
      transitionSuccess: 'Status updated',
      unknownOperator: 'Unknown operator',
    },
    empty: 'No apps to process',
    errorDescription: 'Try again later, or check whether this admin still has access.',
    errorTitle: 'Failed to load publishing review list',
    table: {
      actions: 'Actions',
      app: 'App',
      appType: 'App type',
      changeType: 'Change type',
      status: 'Status',
      updatedAt: 'Updated at',
      version: 'Version',
    },
    title: 'Publishing review',
    workspaceLabel: 'Publishing review workspace',
  },
  pagination: {
    next: 'Next page',
    pageSize: '{{count}} / page',
    previous: 'Previous page',
  },
  retry: 'Retry',
  status: {
    active: 'Active',
    banned: 'Banned',
    draft: 'Draft',
    pending_publish: 'Pending',
    testing: 'Testing',
  },
  sort: {
    createdAtAsc: 'Sort by created time ascending',
    createdAtDesc: 'Sort by created time descending',
    updatedAtAsc: 'Sort by updated time ascending',
    updatedAtDesc: 'Sort by updated time descending',
  },
  table: {
    actions: 'Actions',
    createdAt: 'Created at',
    description: 'Description',
    name: 'App',
    status: 'Status',
    type: 'App type',
    updatedAt: 'Updated at',
    version: 'Version',
  },
  title: 'Apps',
  workspaceLabel: 'Apps workspace',
}

export default adminApps
